<template>
  <div class="control has-icons-left">
    <div class="select" :class="{ 'is-medium': large }">
      <select
        class="statusSelector"
        v-model="status"
        :disabled="['Playing'].includes(status)"
        @change="(e) => updateStatus(e.target.value)"
        @click="
          (e) => {
            e.stopPropagation();
          }
        "
      >
        <option :value="ONLINE_STATUS.ACTIVE">Active</option>
        <option :value="ONLINE_STATUS.AWAY" v-show="false">Away</option>
        <option :value="ONLINE_STATUS.PLAYING" v-show="false">
          Playing
        </option>
        <option :value="ONLINE_STATUS.BUSY">Busy</option>
        <option :value="ONLINE_STATUS.OFFLINE">Logout</option>
      </select>
    </div>
    <div class="icon is-large is-left">
      <i class="fas" :class="statusIcon"></i>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { ONLINE_STATUS } from "../../constants";

export default {
  name: "StatusSelector",

  props: ["large"],

  data() {
    return {
      status: "",
      ONLINE_STATUS: ONLINE_STATUS,
    };
  },

  computed: {
    ...mapGetters({
      onlineStatus: "getOnlineStatus",
      isAway: "getIsAway",
      isPlayingTournament: "getIsPlayingTournament",
    }),

    statusIcon() {
      switch (this.onlineStatus) {
        case ONLINE_STATUS.ACTIVE:
          return "fa-globe-asia has-text-success";
        case ONLINE_STATUS.AWAY:
          return "fa-clock has-text-warning";
        case ONLINE_STATUS.PLAYING:
          if (this.isPlayingTournament) {
            return "fa-trophy has-text-info";
          } else {
            return "fa-chess-board has-text-info";
          }
        case ONLINE_STATUS.BUSY:
        case ONLINE_STATUS.OFFLINE:
          return "fa-ban has-text-danger";
        default:
          return "";
      }
    },
  },

  watch: {
    onlineStatus: {
      immediate: true,
      handler() {
        this.status = this.onlineStatus;
      },
    },
  },

  methods: {
    ...mapActions(["setIsBusy"]),

    updateStatus(status) {
      if (status === ONLINE_STATUS.OFFLINE) {
        localStorage.removeItem("accessToken");
        window.location = "https://www.chesssquad.com/logout.php";
      } else if (status === ONLINE_STATUS.BUSY) {
        this.setIsBusy(true);
      } else {
        this.setIsBusy(false);
      }
    },
  },
};
</script>

<style scoped>
.statusSelector,
.statusSelector:disabled {
  background-color: transparent;
  color: inherit;
  font-weight: 600;
  border: none;
}
</style>
